import api from '../config/api';

const organizationService = {
  getMyOrganizations: () => api.get('/organizations/mine'),
  getCurrent: () => api.get('/organizations/current'),
  updateCurrent: (data) => api.put('/organizations/current', data),
  uploadLogo: (formData) => api.post('/organizations/current/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // Members
  getMembers: () => api.get('/organizations/current/members'),
  addMember: (data) => api.post('/organizations/current/members', data),
  removeMember: (userId) => api.delete(`/organizations/current/members/${userId}`),
  updateMemberRole: (userId, roleId) => api.put(`/organizations/current/members/${userId}/role`, { roleId }),

  // Roles & Permissions
  getRoles: () => api.get('/organizations/current/roles'),
  createRole: (data) => api.post('/organizations/current/roles', data),
  updateRole: (roleId, data) => api.put(`/organizations/current/roles/${roleId}`, data),
  deleteRole: (roleId) => api.delete(`/organizations/current/roles/${roleId}`),
  getPermissions: () => api.get('/organizations/current/permissions'),
  getRolePermissions: (roleId) => api.get(`/organizations/current/roles/${roleId}/permissions`),
  updateRolePermissions: (roleId, permissionIds) =>
    api.put(`/organizations/current/roles/${roleId}/permissions`, { permissionIds }),

  // Issue Types
  getIssueTypes: () => api.get('/organizations/current/issue-types'),
  createIssueType: (data) => api.post('/organizations/current/issue-types', data),
  updateIssueType: (id, data) => api.put(`/organizations/current/issue-types/${id}`, data),
  deleteIssueType: (id) => api.delete(`/organizations/current/issue-types/${id}`),

  // Labels
  getLabels: () => api.get('/organizations/current/labels'),
  createLabel: (data) => api.post('/organizations/current/labels', data),
  updateLabel: (id, data) => api.put(`/organizations/current/labels/${id}`, data),
  deleteLabel: (id) => api.delete(`/organizations/current/labels/${id}`),

  // Custom Fields
  getCustomFields: () => api.get('/organizations/current/custom-fields'),
  createCustomField: (data) => api.post('/organizations/current/custom-fields', data),
  updateCustomField: (id, data) => api.put(`/organizations/current/custom-fields/${id}`, data),
  deleteCustomField: (id) => api.delete(`/organizations/current/custom-fields/${id}`),

  // Notification Defaults
  getNotificationDefaults: () => api.get('/organizations/current/notification-defaults'),
  updateNotificationDefaults: (data) => api.put('/organizations/current/notification-defaults', { notificationDefaults: data }),

  // Invitations
  sendInvitation: (data) => api.post('/invitations', data),
  bulkInvite: (formData) => api.post('/invitations/bulk', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getInvitations: () => api.get('/invitations'),
  cancelInvitation: (id) => api.delete(`/invitations/${id}`),
  resendInvitation: (id) => api.post(`/invitations/${id}/resend`),
  getInviteInfo: (token) => api.get(`/invitations/info/${token}`),
  acceptInvite: (token) => api.post(`/invitations/accept/${token}`),
  declineInvite: (token) => api.post(`/invitations/decline/${token}`),

  // Join Requests
  getJoinRequests: () => api.get('/invitations/join-requests'),
  approveJoinRequest: (id, roleId) => api.post(`/invitations/join-requests/${id}/approve`, { roleId }),
  rejectJoinRequest: (id) => api.post(`/invitations/join-requests/${id}/reject`),
  searchOrgs: (q) => api.get('/invitations/orgs/search', { params: { q } }),
  requestToJoin: (orgId, msg) => api.post('/invitations/join', { organizationId: orgId, message: msg }),
};

export default organizationService;
